import { defineMessages } from 'react-intl';

/**
 * UI chrome copy for the Heidi Work Research Preview supplemental terms modal.
 * The legal terms body itself is rendered verbatim (not localised) from the
 * source-of-truth text in `ResearchPreviewTermsModal`.
 */
export const researchPreviewTermsMessages = defineMessages({
  badge: {
    defaultMessage: 'Research Preview',
    id: 'lpo0V3Xfas',
    description: 'Badge label marking the Work surface as a research preview',
  },
  title: {
    defaultMessage: 'Heidi Work is in Research Preview',
    id: 'cwTVl1SLoA',
    description: 'Title of the Research Preview supplemental terms modal',
  },
  description: {
    defaultMessage: 'You must accept the supplemental terms of use to proceed.',
    id: 'crs9CgWRkl',
    description: 'Subtitle instructing the user they must accept to continue',
  },
  termsHeading: {
    defaultMessage: 'Heidi Research Supplemental Terms of Use',
    id: 'OOHhGCkUyA',
    description: 'Heading of the scrollable terms card',
  },
  downloadAria: {
    defaultMessage: 'Download the supplemental terms',
    id: 'M12j2Qa5No',
    description: 'Accessible label for the button that downloads the terms as a file',
  },
  confirmIntro: {
    defaultMessage: 'By checking the box, I confirm that:',
    id: 'P1ywCmArSM',
    description: 'Lead-in line above the list of acceptance confirmations',
  },
  acceptCheckboxLabel: {
    defaultMessage: 'I accept the Heidi Research Supplemental Terms of Use',
    id: 'YeqyaPakrx',
    description: 'Label for the mandatory acceptance checkbox',
  },
  declineButton: {
    defaultMessage: 'Decline',
    id: 'vvOeVA2oIF',
    description: 'Button that declines the terms and exits the Work surface',
  },
  continueButton: {
    defaultMessage: 'Continue',
    id: 'mRprM6DAuS',
    description: 'Primary button that confirms acceptance and proceeds into Work',
  },
});
